import {
  Home,
  About,
  Contact,
  NotFound,
  PrivacyPolicy,
  TermsAndConditions,
  LoginRegister,
  Faqs,
  ForgotPassword,

} from "../../pages/index";
const allRoutes = [
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "about",
    element: <About />,
  },
  {
    path: "contact",
    element: <Contact />,
  },
  {
    path: "faqs",
    element: <Faqs />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "login-register",
    element: <LoginRegister />,
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />,
  },
];

export default allRoutes;